// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import { App } from "./app";
import router from "./router";
import store from "./store";
import VueYoutube from "vue-youtube";
import jQuery from "jquery";
import Notifications from "vue-notification";
import AWS from "aws-sdk";
import Datatable from "vue2-datatable-component";
import VueFire from "vuefire";
import linkify from "vue-linkify";
import vSelect from "vue-select";
import Donut from "vue-css-donut-chart";
import Switches from "vue-switches";
import ToggleButton from "vue-js-toggle-button";
import "vue-css-donut-chart/dist/vcdonut.css";
import VueTour from "vue-tour";
import IdleVue from "idle-vue";
import VPopover from "vue-js-popover";
import JsonCSV from "vue-json-csv";
import Multiselect from "vue-multiselect";
import VueSweetalert2 from "vue-sweetalert2";
import i18n from "./i18n";
import debounce from "lodash/debounce";

import "sweetalert2/dist/sweetalert2.min.css";

require("vue-tour/dist/vue-tour.css");

window.jQuery = jQuery;
window.$ = jQuery;

Vue.use(VueYoutube);
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(AWS);
Vue.use(Datatable);
Vue.use(VueFire);
Vue.use(Donut);
Vue.use(ToggleButton);
Vue.use(VueTour);
Vue.use(VPopover, { tooltip: true });
Vue.component("switches", Switches);
Vue.component("v-select", vSelect);
Vue.directive("linkified", linkify);
Vue.component("downloadCsv", JsonCSV);
Vue.component("multiselect", Multiselect);
Vue.use(VueSweetalert2);

Vue.mixin({
  computed: {
    LABELS: function () {
      return store.state.institution.institutionLabels;
    },
  },
  methods: {
    //translate with fallback
    $tf(key, fallback = null, values = {}) {
      const translation = this.$t(key, values);
      return translation === key ? fallback : translation;
    },
  },
});

// PRAGYA VERTEX WIDGET
// ==============================

// Utility: Creates a new Pragya Widget with given HTML-like attributes
function createPragyaWidget(attributes = {}) {
  const widget = document.createElement("pragya-widget");
  widget.id = "pragya-assistant-widget";

  Object.entries(attributes).forEach(([key, value]) => {
    widget.setAttribute(key, value);
  });

  document.body.appendChild(widget);
  return widget;
}

// Core Logic: Update widget props or mount/unmount based on context
Vue.prototype.$updatePragyaWidget = debounce(function () {
  // Guard: Don't run if we're in the middle of initialization
  if (!store || !store.state) {
    return;
  }

  const institution =
    store.state.institution && store.state.institution.institution;
  const userRole = store.state.user && store.state.user.userRole;
  const userId = store.state.user && store.state.user.userObj && store.state.user.userObj.uuid;
  const userFullName = store.state.user && store.state.user.userFullName;
  const userFirstName =
    typeof userFullName === "string" && userFullName.trim().length
      ? userFullName.trim().split(/\s+/)[0]
      : "";
  const localStorageInstitutionId = localStorage.getItem("institutionId");
  let isAiBotEnabled = false;

  // Check AI feature flag from institution packages
  if (institution && institution.packages && institution.packages.length) {
    const pkg = institution.packages.find(
      (pkg) => pkg.packageId === "PKG_AI_001"
    );
    const feature =
      pkg &&
      pkg.features &&
      pkg.features.find((f) => f.featureId === "AI Assistant Bot");
    isAiBotEnabled = (feature && feature.enabled) || false;
  }

  const shouldShowWidget =
    !!institution && !!userRole && !!localStorageInstitutionId && isAiBotEnabled;

  let widget = document.querySelector("#pragya-assistant-widget");

  // Remove widget if context is invalid
  if (!shouldShowWidget) {
    if (widget) {
      widget.remove();
    }
    return;
  }

  // Create new widget if not already mounted
  if (!widget) {
    widget = createPragyaWidget({});
  }

  // Ensure it's visible
  widget.style.display = "";

  // Set up widget context props
  // Extract the current tenant ID (institution's openId) or default to "0" (pragya systems))
  const tenant = (institution && institution.openId) || "0";

  // Get the current route path
  const currentPath = router.currentRoute.path;

  // Determine if the user is currently on a course page
  const isInCoursePage = currentPath.includes("/course/");

  // Set the context based on the current route
  // If in a course page, context is "course", otherwise it's "dashboard"
  const context = isInCoursePage ? "course" : "dashboard";

  // Determine the course ID only if we're on a course page
  // This ensures the widget gets correct course-specific context
  const courseId =
    isInCoursePage && store.state.course && store.state.course.course
      ? store.state.course.course.uuid
      : null;

  let competencyId = null;
  let microCompetencyId = null;
  let kcId = null;

  const entity = store.state.course.entity;
  if (
    (!competencyId || !microCompetencyId) &&
    entity &&
    entity.uuid &&
    entity.objectType === "LearningTopic"
  ) {
    if (entity.ancestor) {
      // Has ancestor -> could be MC (if ancestor is not course) or C (if ancestor is course)
      const topicsMap = store.state.course.topicsMap;
      const ancestor = topicsMap && topicsMap[entity.ancestor];

      if (ancestor) {
        if (ancestor.objectType === "LearningTopic" && !competencyId) {
          // Ancestor is a topic -> this entity is a MicroCompetency, ancestor is Competency
          competencyId = String(entity.ancestor);
          if (!microCompetencyId) {
            microCompetencyId = String(entity.uuid);
          }
        } else if (
          ancestor.uuid ===
            (store.state.course.course && store.state.course.course.uuid) &&
          !competencyId
        ) {
          // Ancestor is the course -> this entity is a Competency
          competencyId = String(entity.uuid);
        }
      } else if (
        entity.ancestor ===
          (store.state.course.course && store.state.course.course.uuid) &&
        !competencyId
      ) {
        // Ancestor is course UUID -> this is a top-level Competency
        competencyId = String(entity.uuid);
      }
    } else if (!competencyId) {
      // No ancestor -> likely a top-level Competency
      competencyId = String(entity.uuid);
    }
  }

  if (
    entity &&
    entity.uuid &&
    (entity.objectType === "LearningContent" || (entity.objectType && entity.objectType.toLowerCase().includes('knowledge')))
  ) {
    kcId = String(entity.uuid);

    if (entity.ancestor) {
      const topicsMap = store.state.course.topicsMap;
      const courseUuid =
        store.state.course.course && store.state.course.course.uuid;
      const parent = topicsMap && topicsMap[entity.ancestor];

      if (parent && courseUuid && parent.ancestor === courseUuid) {
        if (!competencyId) {
          competencyId = String(entity.ancestor);
        }
      } else {
        if (!microCompetencyId) {
          microCompetencyId = String(entity.ancestor);
        }
        if (!competencyId && parent && parent.ancestor) {
          competencyId = String(parent.ancestor);
        }
      }
    }
  }

  const systemInstructions = `You are Compass, a helpful assistant. When responding:
1. Greet the user only if the user greets you.
2. Keep answers brief and focused - aim for only 1 short paragraphs
3. Use simple, direct language and get straight to the point
4. Break information into bullet points when listing multiple items
5. Prioritize the most relevant information that directly answers the user's question
6. Avoid lengthy explanations, background information, or exhaustive details
7. If the complete answer would be lengthy, provide a concise summary and offer to elaborate if the user requests more details
8. Use a friendly, helpful tone while being efficient with words
9. For complex topics, focus on the core concept first, then add details only if necessary

Remember that you're responding in a compact widget interface where brevity and clarity are essential.
`;

  const internalProps = {
    systemInstructions,
    tenant,
    context,
    role: userRole,
    userId: userId,
      kcId: kcId,
  };

  if (context === "course" && courseId) {
    internalProps.course = courseId;
    if (competencyId) {
      internalProps.competency = competencyId;
    }
    if (microCompetencyId) {
      internalProps.microCompetency = microCompetencyId;
    }
  }

  Vue.nextTick(() => {
    widget.internalProps = internalProps;
  });
}, 500);

// ==============================
// Vue Global Mixin
// ==============================

let courseWatcherInitialized = false;

Vue.mixin({
  mounted() {
    // Use nextTick to ensure DOM and store are fully initialized
    Vue.nextTick(() => {
      this.$updatePragyaWidget();
    });

    if (!courseWatcherInitialized && this.$store) {
      courseWatcherInitialized = true;

      const store = this.$store;

      // Watch: Course changes
      store.watch(
        (state) =>
          state.course && state.course.course ? state.course.course.uuid : null,
        () => {
          this.$updatePragyaWidget();
        }
      );

      // Watch: Entity changes (for competency/microCompetency context)
      store.watch(
        (state) =>
          state.course && state.course.entity ? state.course.entity.uuid : null,
        () => {
          this.$updatePragyaWidget();
        }
      );

      // Watch: Entity competency changes (primary source for competency IDs)
      store.watch(
        (state) =>
          state.course && state.course.entityCompetency
            ? JSON.stringify(state.course.entityCompetency)
            : null,
        () => {
          this.$updatePragyaWidget();
        }
      );

      // Watch: Linear topics changes (for competency hierarchy)
      store.watch(
        (state) =>
          state.course && state.course.linearTopics
            ? state.course.linearTopics.length
            : 0,
        () => {
          this.$updatePragyaWidget();
        }
      );

      // Watch: Institution data load/change
      store.watch(
        (state) => state.institution && state.institution.institution,
        (newVal) => {
          if (newVal) {
            this.$updatePragyaWidget();
          }
        }
      );

      // Watch: User role availability
      store.watch(
        (state) => state.user && state.user.userRole,
        (newVal) => {
          if (newVal) {
            this.$updatePragyaWidget();
          }
        }
      );
    }
  },
});

// ==============================
// Router Hook for Route-Based Updates
// ==============================

router.afterEach(() => {
  Vue.nextTick(() => {
    Vue.prototype.$updatePragyaWidget();
  });
});

// END OF WIDGET CONFIGURATION

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 28740000, // 28740 secondes (7 hours and 59 minutes)
  startAtIdle: false,
});

/*
router.afterEach((to, from) => {
  if (to.name && to.name !== 'login') {
    let loginTime = (new Date()).getTime()
    localStorage.setItem('loginTime', loginTime)
  }
})
*/

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js